import { graphql } from "react-relay";

/////////
// GQL //
/////////

export const fragments = {
  org: graphql`
    fragment OnboardingTeamJoinCreateStep_org on Org {
      ...TeamJoinCreate_org
      id
      id
      userTeams {
        __typename
        ... on TeamList {
          list {
            id
            teamId
            teamName
            createdBy {
              value
            }
            teamCalendarId
            settings {
              __typename
              ... on TeamSettings {
                manageTeamCalendar
              }
            }
            userSettings {
              __typename
              ... on TeamUserSettings {
                useTeamCalendar
              }
            }
            invitedMembers {
              addedBy
              person {
                __typename
                id
                primaryCalendarId
                isYou
                userId
                profile {
                  givenName
                  familyName
                  externalImageUrl
                }
              }
            }
            teamMembers {
              addedBy
              person {
                __typename
                id
                primaryCalendarId
                isYou
                userId
                profile {
                  givenName
                  familyName
                  externalImageUrl
                }
              }
            }
          }
        }
      }
    }
  `,
  viewer: graphql`
    fragment OnboardingTeamJoinCreateStep_viewer on Viewer
    @argumentDefinitions(orgRelayId: { type: "ID!" }, myCalendarIds: { type: "[String!]!" }) {
      ...TeamJoinCreate_viewer @arguments(orgRelayId: $orgRelayId, myCalendarIds: $myCalendarIds)
      user {
        id
      }
      id
    }
  `,
};
